import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { SupplierForecastRepository } from '@/coreInfrastructureModule/Repositories/SupplierForecastRepository';
import {
  BulkPostSupplierForecastByCustomerForecastRequest,
  BulkSupplierForecastResponseInfo,
} from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';
import { IYearMonth } from '@/coreDomainsModule/date';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { BulkPostSupplierForecastAdapter } from '../adapter/bulkPostSupplierForecastAdapter';

/**
 * 仕入先内示保存のビジネスロジック
 */
export class BulkPostSupplierForecastUseCase {
  /**
   * 仕入先内示に使用するUseCase
   * 客先内示情報を元に仕入先内示を登録する
   * @param repository - 仕入先内示情報の永続化の責務を負うクラス
   * @param createdYearMonth - 仕入先内示作成月
   * @param startForecastTargetYearMonth - 内示対象月の開始月
   * @param forecastTargetYearMonthCount - 内示対象月の数
   * @param filterItems - フィルター項目
   * @param userUpsert - upsert処理を実行するかのフラグ
   */
  async Execute(
    repository: SupplierForecastRepository,
    createdYearMonth: IYearMonth,
    startForecastTargetYearMonth: IYearMonth,
    forecastTargetYearMonthCount: number,
    filterItems?: FilterContentItem[],
    userUpsert = false
  ): Promise<INetworkResult<BulkSupplierForecastResponseInfo, Error>> {
    // アダプター
    const requestInfo = BulkPostSupplierForecastAdapter.adapt(
      createdYearMonth,
      startForecastTargetYearMonth,
      forecastTargetYearMonthCount,
      filterItems
    );

    // requestで送る情報
    const requestBody: BulkPostSupplierForecastByCustomerForecastRequest = {
      useUpsert: userUpsert,
      bulkPostSupplierForecastByCustomerForecastRequestInfo: requestInfo,
    };

    try {
      const result = await repository.bulkPostByCustomerForecast(requestBody);
      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: error as Error,
        },
      };
    }
  }
}
